/**
 * Ladezustand als Skeleton **in der Zielform**, nicht als Spinner.
 *
 * Ein Spinner sagt „warte"; ein Skeleton sagt „hier kommen sechs Zeilen". Der
 * Unterschied ist, dass der Inhalt beim Eintreffen nicht springt — und ein
 * Sprung ist auf dem Telefon der Grund, warum man daneben tippt.
 *
 * Deshalb bekommt die Skeleton-Zeile dieselbe Höhe wie die echte Zeile:
 * `--row-h`, also 48px am Daumen und 36px am Zeiger.
 */

interface SkeletonRowsProps {
  /** So viele Zeilen, wie die Ansicht üblicherweise zeigt. */
  readonly rows?: number
  readonly testId: string
}

export function SkeletonRows({ rows = 6, testId }: SkeletonRowsProps) {
  return (
    <div data-testid={testId} aria-busy="true" aria-live="polite" className="flex flex-col">
      <span className="sr-only">Wird geladen</span>
      {Array.from({ length: rows }, (_, index) => (
        <div
          key={index}
          className="border-border flex h-(--row-h) items-center border-b px-(--page-x)"
        >
          <div className="bg-border h-2 w-full max-w-80 animate-pulse rounded-full" />
        </div>
      ))}
    </div>
  )
}
